import React from 'react';
import { Sparkle } from '@phosphor-icons/react';

export default function CustomIdeaForm({ symbol, setSymbol, context, setContext, onGenerate, isGenerating }) {
  return (
    <div className="bg-[#12141A] border border-white/10 p-6 mb-6" data-testid="freeform-idea-section">
      <h3 className="text-xl font-heading font-bold tracking-tight text-white mb-4">
        Ask for a Custom Trade Idea
      </h3>
      <div className="space-y-4">
        <FormField label="Stock Symbol (Optional)">
          <input
            type="text"
            value={symbol}
            onChange={(e) => setSymbol(e.target.value.toUpperCase())}
            placeholder="e.g., RELIANCE, TCS, HDFCBANK, INFY"
            className="w-full px-3 py-2 bg-[#0A0B0E] border border-white/10 text-white text-sm focus:outline-none focus:border-[#A855F7] transition-colors"
            data-testid="ai-symbol-input"
          />
        </FormField>

        <FormField label="Market Context (Optional)">
          <textarea
            value={context}
            onChange={(e) => setContext(e.target.value)}
            placeholder="Add any market context or specific requirements..."
            rows={3}
            className="w-full px-3 py-2 bg-[#0A0B0E] border border-white/10 text-white text-sm focus:outline-none focus:border-[#A855F7] transition-colors"
            data-testid="ai-context-input"
          />
        </FormField>

        <button
          onClick={onGenerate}
          disabled={isGenerating}
          className="bg-[#A855F7] hover:bg-purple-600 text-white px-6 py-2.5 text-sm font-medium transition-colors disabled:opacity-50 flex items-center gap-2"
          data-testid="ai-generate-button"
        >
          <Sparkle size={20} weight="fill" />
          {isGenerating ? 'Generating...' : 'Generate Trade Idea'}
        </button>
      </div>
    </div>
  );
}

function FormField({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-[0.2em] text-[#94A3B8] mb-2">
        {label}
      </label>
      {children}
    </div>
  );
}
